import React from 'react';
import { observer } from 'mobx-react';
import { Tooltip } from 'antd';
import { CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { apiConfig } from '../../../REST';
import { IInvoicePdfFileStatus } from '../../../interfaces';
import { useInvoice } from '../../../hooks';
import { dateText2Text } from '../../../instruments';
import { CardInfoToolBar, CardMainLayout, Catcher, FieldInfo, FileTypeIcons, LinkComponent } from '../../../Components';
import StylesIcon from '../../IconComponents/m_styles.less';
import StylesLink from '../../LinkComponent/m_styles.less';

export const getInvoiceStatusContent = (fileUrl: string | null, status?: IInvoicePdfFileStatus) => {
    switch (status) {
        case 'processing':
            return (
                <div style={{ display: 'flex', alignItems: 'center', color: '#1890ff' }}>
                    <LoadingOutlined style={{ fontSize: '30px', marginRight: '10px' }} />
                    <span>Processing...</span>
                </div>
            );
        case 'error':
            return (
                <div style={{ display: 'flex', alignItems: 'center', color: '#ff4d4f' }}>
                    <CloseCircleOutlined style={{ fontSize: '30px', marginRight: '10px' }} />
                    <span>Failed to generate PDF</span>
                </div>
            );
        case 'generated':
            return (
                <Tooltip title="Download PDF">
                    <a href={`${apiConfig.apiUrl()}${fileUrl}`} className={StylesLink.linkItem} title="Download PDF">
                        <FileTypeIcons fileType={'pdf'} className={StylesIcon.icon} />
                    </a>
                </Tooltip>
            );
        default:
            return null;
    }
};

export const ShowInvoice: React.FC = observer(() => {
    const item = useInvoice();
    return (
        <Catcher>
            <CardMainLayout idSpinners={['GET_INVOICE']} name={item.code}>
                <FieldInfo title={'ID'}>{item.id}</FieldInfo>
                <FieldInfo title={'Code'}>{item.code}</FieldInfo>
                <FieldInfo title={'Iteration'}>{item.invoiceIteration}</FieldInfo>
                <FieldInfo title={'Buyer'}>
                    {item.buyerId ? (
                        <LinkComponent
                            currentListComponent={'BillingCompaniesList'}
                            id={item.buyerId.toString()}
                            isLight
                            name={item.buyer}
                        />
                    ) : (
                        item.buyer
                    )}
                </FieldInfo>
                <FieldInfo title={'Seller'}>
                    {item.sellerId ? (
                        <LinkComponent
                            currentListComponent={'BillingCompaniesList'}
                            id={item.sellerId.toString()}
                            isLight
                            name={item.seller}
                        />
                    ) : (
                        item.seller
                    )}
                </FieldInfo>
                <FieldInfo title={'Date'}>{dateText2Text(item.date)}</FieldInfo>
                <FieldInfo title={'Sent at'}>{dateText2Text(item.sentAt)}</FieldInfo>
                <FieldInfo title={'Invoice'}>
                    {item.fileUrl ? getInvoiceStatusContent(item.fileUrl, item.pdfFileStatus) : null}
                </FieldInfo>
                <CardInfoToolBar />
            </CardMainLayout>
        </Catcher>
    );
});
